<template>
  <runBlock
      v-for="(item, index) in runList"
      :key="item"
      :item="item"
      :index="index"
      class="animate__animated animate__fadeInDown"
  ></runBlock>
</template>

<script>
//引入跑步展示
import runBlock from "./mobileRunBlock";
//axios
import {getRequest} from "@/utils/service";
import {baseUrl} from "@/utils/request";
//elm
import {ElMessage} from "element-plus";
//节流
import {throttle} from "throttle-debounce";

export default {
  name: "runList",
  components: {runBlock},
  data() {
    return {
      baseUrl: '',
      //子组建数组
      runList: [],
      //页码
      page: 1,
      //是否到底
      isFinal: true
    }
  },
  created() {
    this.baseUrl = baseUrl();
    //加载首次
    this.loadRunnerList();
  },
  mounted() {
    // 性能优化：节流，每隔一段固定的时间，再去执行指定的功能
    this.loading = throttle(300, this.scroll.bind(this));
    window.addEventListener("scroll", this.loading);
  },
  destroyed() {
    // 防止组件被解绑之后，监听事件依然存在，需要解绑
    window.removeEventListener("scroll", this.loading);
  },
  methods: {
    //下拉方法
    scroll() {
      //变量scrollTop是滚动条滚动时，距离顶部的距离
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;

      //变量windowHeight是可视区的高度
      let windowHeight = document.documentElement.clientHeight || document.body.clientHeight;

      //变量scrollHeight是滚动条的总高度
      let scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;

      //滚动条到底部的条件
      if (scrollTop + windowHeight + 1 >= scrollHeight) {
        //到了这个就可以进行业务逻辑加载后台数据了
        if (this.isFinal) {
          this.loadRunnerList();
        }
      }
    },
    //加载文章列表
    loadRunnerList() {
      //判断页码
      let page = this.page;

      getRequest(this.baseUrl + '/run/getRunner?page=' + page + '&limit=5')
          .then((res) => {
            let data = res.data.data;
            if (data.length == 0) {
              ElMessage.warning('已经到底啦....')
              this.isFinal = false;
            } else {
              //放入集合
              for (let i = 0; i < data.length; i++) {
                //照片判断
                if (data[i].img == ' ') {
                  data[i].img = '';
                } else {
                  data[i].img = this.baseUrl + data[i].img;
                }
                //放
                this.runList.push(data[i]);
              }

              //页码增加
              this.page = page + 1;
            }
          })
          .catch(function (error) {
            ElMessage.error(error)
          })
    },
  }
}
</script>

<style scoped>

</style>